module.exports = __webpack_public_path__ + "img/deck-min.35316f57.jpg";